<template>
  <div class="wrap1">
    <h2 class="common-title">
      <i class="el-icon-arrow-left icon" @click="handlerBack"></i>
      {{ $t('i18n.8332aec5e5f2411f802b111838a71072') }}
    </h2>
    <div class="wrap1-box">
      <div class="record">
        <p class="name">{{ $t('payroll_management_31') }}：{{ tableData.staffInfo.staff_name || '--' }}</p>
        <p class="department">{{ $t('27') }}：{{ tableData.staffInfo.department_name || '--' }}</p>
        <p>{{ $t('1516') }}：{{ tableData.staffInfo.hire_date || '--' }}</p>
      </div>
      <el-table :data="tableData.list" ref="table" style="width: 100%" :max-height="tableHeight">
        <el-table-column
          v-for="item in tableData.columns"
          :key="item.prop"
          :label="item.label"
          :width="item.width || 'auto'"
          :prop="item.prop"
        >
          <template slot-scope="{ row }">
            <template
              v-if="
                item.prop === 'update_reason_file' &&
                typeof row.update_reason_file === 'string' &&
                row.update_reason_file.indexOf('http') !== -1
              "
            >
              <el-button type="text" @click="onClick(row[item.prop])">{{ $t('64') }}</el-button>
            </template>
            <span v-else :class="Number(row.status) === 4 ? 'isDisabled' : ''">{{ row[item.prop] }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" :label="$t('70')" min-width="190" fixed="right">
          <template slot-scope="{ row }">
            <el-button v-if="Number(row.status) !== 4" type="text" @click="handleEdit(row, 'edit')">{{
              $t('71')
            }}</el-button>
            <el-button v-if="Number(row.status) === 4" type="text" @click="handleEdit(row, 'check')">{{
              $t('64')
            }}</el-button>
            <el-button v-if="row.is_cancel" type="text" @click="handleRevoke(row)">{{ $t('cancel') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <change-salary ref="changeSalary" @save="init(1)"></change-salary>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { tableConfig } from './components/config.js'
import { getLogList, getSalaryNotice, repealSalaryDate } from '@/api/payroll'
import ChangeSalary from './modal/change-salary'

export default {
  components: { ChangeSalary },
  data() {
    return {
      tableData: {
        list: [],
        columns: {},
        staffInfo: {}
      },
      pageSizes: [20, 50, 100],
      staff_id: this.$route.params.staff_id,
      settlement_type: '1',
      page: {
        currPage: 1,
        limit: 20,
        total: 100
      },
      year: new Date().getFullYear().toString()
    }
  },
  computed: {
    ...mapState({
      contentViewHeight: state => state.settings.contentViewHeight
    }),
    tableHeight() {
      return this.contentViewHeight - 130
    }
  },
  created() {
    this.init(1)
  },
  methods: {
    init(page) {
      this.page.currPage = page
      // 调薪纪录
      this.tableData = { list: [], columns: {}, staffInfo: {} }
      getLogList({
        staff_info_id: this.staff_id
        // page_size: this.page.limit,
        // page
      }).then(res => {
        if (res.data) {
          this.tableData.staffInfo = res.data.staff_info || {}
          this.tableData.list = res.data.list || []
          this.tableData.columns = this.handleColumn(res.data.columns || {})
        }
        this.$nextTick(() => {
          if (this.$refs.table) this.$refs.table.doLayout()
        })
      })
    },
    // 处理表头数据
    handleColumn(columns) {
      const arr = []
      tableConfig.forEach(item => {
        if (columns[item.prop]) {
          arr.push(item)
          delete columns[item.prop]
        }
      })
      if (Array.isArray(columns)) return
      const keys = Object.keys(columns)
      keys.forEach(item => {
        arr.push({ edit: false, type: '', label: columns[item], prop: item, width: 200 })
      })

      return arr
    },
    // 编辑or查看
    handleEdit(row, status) {
      this.$set(row, 'statusEdit', status)
      this.$refs.changeSalary.init(row)
    },
    // 撤销
    handleRevoke(row) {
      getSalaryNotice({ staff_info_id: this.staff_id, salary_update_start_date: row.update_start_date }).then(res => {
        if (res.data && res.data.is_show) {
          this.$confirm(
            this.$t('i18n.c219790c6b4f4d07b4a8d59ec8250b61'),
            this.$t('i18n.3c395f46dbef4318872c345723b60426'),
            {
              confirmButtonText: this.$t('131'),
              cancelButtonText: this.$t('66'),
              type: 'warning'
            }
          )
            .then(() => {
              this.repealSalaryDate(row)
            })
            .catch(() => {})
        } else {
          this.repealSalaryDate(row)
        }
      })
    },
    repealSalaryDate(row) {
      repealSalaryDate({ id: row.id, staff_info_id: this.staff_id }).then(() => {
        this.init(1)
      })
    },
    handlerBack() {
      this.$router.go(-1)
    },
    // 查看文件
    onClick(url) {
      window.open(url)
    }
    // handleSizeChange(val) {
    //   this.page.limit = val
    //   this.init(1)
    // },
    // handleCurrentChange(val) {
    //   this.init(val)
    // },
  }
}
</script>
<style lang="scss" scoped>
.wrap1 {
  &-box {
    padding: 0px 24px 0 24px;
    .isDisabled {
      color: #8c8c8c;
    }
  }
  .record {
    padding: 24px 0;
    text-align: center;
    p {
      font-size: 14px;
      color: #595959;
    }
    .name {
      font-weight: 500;
      font-size: 20px;
      color: #262626;
    }
    .department {
      padding: 16px 0 8px 0;
    }
  }
  .revoke {
    font-size: 14px;
    color: #8c8c8c;
  }
}
.icon {
  margin-right: 24px;
  cursor: pointer;
}
</style>
